/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    object, shape, arrayOf, string,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import Slider from 'react-slick';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import MobileClubPageStyle from './style/MobileClubPageStyle';
import SubCollection from '../../ContentTypeComponents/SubCollection/SubCollection';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import BlockHeading from '../../ContentTypeComponents/BlockHeading';
import normalizeAltCopy from '../../../helpers/normalizeAltCopy';

const useStyles = makeStyles((theme) => MobileClubPageStyle(theme));

const MobileClubPage = ({
    clubTypeContent, Disclaimer, featureFlags, heading, moreText, headerbackground, subcollectionBlock, titleFontFamily,
}) => {
    const seed = useUIDSeed();
    const dispatch = useDispatch();
    const classes = useStyles({ titleFontFamily });
    const tackEventClick = (clubgaTag, gaLabel) => {
        dispatch(trackEvent({
            eventCategory: clubgaTag?.gaConstants?.tracking_event_category || '',
            eventAction: clubgaTag?.gaConstants?.tracking_event_action || '',
            eventLabel: gaLabel?.club_product?.tracking_event_label || '',
        }));
    };
    return (
        <div data-testid="mobile-club-container">
            {!moreText && (
                <div className={classes.main}>
                    <div className={classes.textHeadingCenter}>
                        <h2 className={classes.heading}>{heading}</h2>
                    </div>
                    <img className={classes.headerSingleImage} src={headerbackground?.url} alt={normalizeAltCopy('banner')} />
                </div>
            )}
            {clubTypeContent?.map((type) => {
                const isFeatured = type.title === 'Featured';
                const gridLength = (type.product_blocks?.length > 2) ? 2.4 : type.product_blocks?.length;
                const domId = type?.title?.replace(' ', '-').toLowerCase();
                return (
                    <div id={domId} key={seed(type)} data-grid={gridLength} className={`${isFeatured ? classes.featuredBackground : ''} ${classes.clubsType}`}>
                        <h4 className={`${isFeatured ? classes.featuredTextColor : ''} ${classes.clubHeading}`}>{type.heading} ({type.product_blocks?.length})</h4>
                        <Slider
                            dots={false}
                            infinite={false}
                            speed={500}
                            slidesToShow={gridLength}
                            slidesToScroll={2}
                            arrows
                            className={`carousel-container ${classes.sliderContainer}`}
                        >
                            {type?.product_blocks?.map((clubData) => (
                                <div key={seed(clubData.club_product)} className={`${isFeatured ? classes.featuredBackground : ''} ${classes.typeData}`}>
                                    <div className={classes.imageMainContainer}>
                                        <div className={classes.code} />
                                        <Link to={clubData.club_product?.url}  onClick={() => tackEventClick(type, clubData)}>
                                            <img className={classes.typeImage} src={(clubData.club_product?.image?.url)} alt={normalizeAltCopy(clubData.club_product?.alternate_text)} />
                                        </Link>
                                    </div>
                                    <div className={classes.content}>
                                        <Link  className={classes.linkContainer} to={clubData.club_product?.url}  onClick={() => tackEventClick(type, clubData)}> <p className={`${isFeatured ? classes.featuredTextColor : ''} ${classes.productLabel}`}>{ReactHtmlParser(clubData.club_product?.label)}</p></Link>
                                        {clubData.club_product?.passport_eligible && featureFlags['is-prime-free-ship-icon-enabled'] && (
                                            <img className={classes.passportEligibleImage} src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt1a8ac8abec129e11/5f3ba5ec48bdc47f3f1e899b/PassportEligible.png" alt={normalizeAltCopy(` ${clubData?.club_product?.label || 'Passport Eligible Banner'} Passport Eligible `)}  />
                                        )}
                                        {clubData.club_product?.price ? <p className={`${isFeatured ? classes.featuredTextColor : ''} ${classes.priceText}`}>Starting at $<span>{clubData.club_product?.price}</span></p>
                                            : <p className={isFeatured ? classes.featuredTextColor : ''}><span>{ReactHtmlParser(clubData.club_product?.description)}</span></p>}
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                );
            })}
            {subcollectionBlock?.length > 0 && subcollectionBlock?.map((block) => (
                <>
                    {block?.heading && <BlockHeading heading={block.heading} />}
                    <SubCollection data={block} />
                </>
            ))}
            {Disclaimer?.map((info) => (
                <div key={seed(info)} className={classes.disclaimer}>
                    <p className={classes.disclaimerHeading}>{info?.heading}</p>
                    <p className={classes.disclaimerContent}>{ReactHtmlParser(info?.content)}</p>
                </div>
            ))}
        </div>
    );
};

MobileClubPage.defaultProps = {
    titleFontFamily: '',

};

MobileClubPage.propTypes = {
    heading: string.isRequired,
    moreText: string.isRequired,
    titleFontFamily: string,
    headerbackground: shape({
        url: string,
    }).isRequired,
    clubTypeContent: arrayOf(shape({
        product_blocks: arrayOf(shape({
            img: string,
            altText: string,
            label: string,
            description: string,
            price: string,
            url: string,
        }).isRequired),
    })).isRequired,
    Disclaimer: arrayOf(shape({
        heading: string,
        content: string,
    })).isRequired,
    featureFlags: object.isRequired,
    subcollectionBlock: arrayOf(shape({
        reference: arrayOf(shape({
            pim_code: string,
        })),
    })).isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default connect(mapStateToProps)(MobileClubPage);
